const doc = [({"ko":({"adminButtonHotel":({"backToHotelShow":"호텔로 돌아가기", "changeChannelManager":"사이트 컨트롤러 변경"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;